export class LogflareService {
  static async sendDataToLogflare(text, number) {
    const logflareUrl =
      "https://api.logflare.app/logs/json?api_key=Et79CgesFsX7&source=adc53b02-747e-46b5-96e7-3b11bea33dc2";
    const logData = {
      message: `${text}: ${number} -`,
      metadata: { number },
    };

    try {
      const response = await fetch(logflareUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(logData),
      });

      if (!response.ok) {
        throw new Error("Failed to log data");
      }

      console.log("Data logged successfully");
    } catch (error) {
      console.error("Error logging data:", error);
    }
  }
}

// Usage: LogflareService.sendDataToLogflare(number);
